export const StudyAnalysis = {
  '学生Tab_知识点掌握': 'Mastery',
  '知识点掌握加载中': 'Loading knowledge mastery...',
  '知识点掌握未绑定': 'Multimodal knowledge library is not enabled for this course',
  '知识点个数': 'Knowledge points',
  '练习总题数': 'Total exercises',
  '章节掌握度': 'Mastery {rate}%',
  '练习题数': 'Exercises',
  '答对': 'Correct',
  '答错': 'Wrong',
  '所属章节': 'Chapter',
  '掌握状态': 'Status',
  '掌握状态_已掌握': 'Mastered',
  '掌握状态_正常': 'Normal',
  '掌握状态_需提高': 'Needs work',
  '掌握状态_未练习': 'Not practiced',
  '暂无知识点学习数据': 'No learning data yet',
  '知识点内容加载中': 'Loading knowledge point...',
  '薄弱项分析': 'Weakness analysis',
  '加载中': 'Loading...',
  '查看AI薄弱项分析': 'View AI weakness analysis',
  'AI薄弱项摘要': 'AI weakness summary',
  '刷新分析': 'Refresh',
  '生成最新分析': 'Generate latest analysis',
  '最新分析时间': 'Latest analysis: {time}',
  '尚未生成分析': 'No analysis generated yet',
  '历史版本': 'History',
  '版本最新': 'Latest',
  '掌握率': 'Mastery rate',
  '整体掌握度': 'Overall mastery',
  '生成冷却提示': 'Please try again in {minutes} min',
  '分析生成中': 'Generating analysis…',
  '薄弱项未绑定知识库': 'This course has no linked knowledge library; weakness analysis is unavailable',
  '薄弱项分析入口描述': 'AI summarizes wrong answers and generates practice',
  '薄弱知识点数': 'Weak points',
  '累计错题数': 'Total wrong answers',
  '练习正确率': 'Practice accuracy',
  '错题分布': 'Wrong answer distribution',
  '错题数': 'Wrong count',
  '薄弱知识点列表': 'Weak knowledge points',
  '暂无薄弱知识点': 'Great! No weak knowledge points',
  '错误率': 'Error rate',
  '做错': 'Wrong',
  '练习': 'Practice',
  '次': 'times',
  '开始巩固练习': 'Start consolidation practice',
  '获取练习失败': 'Failed to load practice, please retry',
  '获取学习数据失败': 'Failed to load data',
  '缺少必要参数': 'Missing parameters',
  '优先级_紧急': 'Urgent',
  '优先级_高': 'High',
  '优先级_中': 'Medium',
  '优先级_低': 'Low',
  '薄弱项分析蒙层标题': 'No AI weakness analysis yet',
  '薄弱项分析蒙层说明': 'Generate a report to see AI summary, wrong-answer distribution, and practice suggestions.',
  '薄弱项分析蒙层按钮': 'Generate analysis now',
  '薄弱项分析蒙层提示': 'Or tap "Generate latest" above',
  '分析进度_汇总错题': 'Aggregating wrong answers…',
  '分析进度_统计薄弱点': 'Analyzing weak points…',
  '分析进度_AI生成摘要': 'AI generating summary…',
  '分析进度_即将完成': 'Almost done…',
  '巩固练习弹窗标题': 'Practice',
}
